import { EditorComponent } from 'components/editor/Editer';
import { PROPERTY_WEBSITE } from 'constants/propertyWebsite';

import UploadCloud from 'assets/images/upload-cloud.svg';
import MinusIcon from 'assets/images/minus.svg';
import { useEffect, useRef, useState } from 'react';

const base_url = process.env.REACT_APP_IMAGE_BASE_URL;

export const AgentsInfo = ({
  info,
  agentsInfos,
  handleDeleteAgent,
  handleChangeAvatar,
  addingImageUrlObj,
  handleClickOnChooseImg,
  handleChangeAgentInput,
  idEquivalenceCheckerCallback,
  setAgentsInfos,
  description,
}) => {
  const [editorValue, setEditorValue] = useState();

  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    if (editorValue) {
      timeoutRef.current = setTimeout(() => {
        const changingAgentIndex = agentsInfos.findIndex((element) =>
          idEquivalenceCheckerCallback(element, info?.id)
        );
        const changingAgent = agentsInfos.find((element) =>
          idEquivalenceCheckerCallback(element, info.id)
        );
        const resAgentsInfos = [
          ...agentsInfos.slice(0, changingAgentIndex),
          {
            ...changingAgent,
            description: editorValue,
          },
          ...agentsInfos.slice(changingAgentIndex + 1),
        ];
        setAgentsInfos(resAgentsInfos);
      }, 500);
    }
  }, [editorValue]);

  return (
    <div key={info.id || info._id} className="agentCard">
      {agentsInfos?.length > 1 && (
        <button
          onClick={() =>
            handleDeleteAgent({
              realId: info.id,
              localId: info._id,
            })
          }
          className="cta-remove"
        >
          <img src={MinusIcon} alt="remove" />
        </button>
      )}
      <div className="row">
        <div className="col-lg-4">
          <div className="avatar">
            <input
              hidden
              id={info.id || info._id}
              type="file"
              onChange={(e) =>
                handleChangeAvatar({
                  e,
                  id: info.id || info._id,
                })
              }
            />
            {addingImageUrlObj[info.id || info._id] || info.photo ? (
              <img
                src={
                  addingImageUrlObj[info.id || info._id] ||
                  `${base_url + info?.photo}`
                }
                alt="avatar"
                title={PROPERTY_WEBSITE.click_upload_image}
                className="w-100 user-avatar-img"
                onClick={() =>
                  handleClickOnChooseImg({
                    id: info.id || info._id,
                  })
                }
              />
            ) : (
              <div
                onClick={() =>
                  handleClickOnChooseImg({
                    id: info.id || info._id,
                  })
                }
                className="uploadImg"
              >
                <label htmlFor="file" className="upload">
                  <i>
                    <img
                      src={UploadCloud}
                      alt="upload"
                      className="w-100 user-avatar-img"
                    />
                  </i>
                  <span>{PROPERTY_WEBSITE.upload_image}</span>
                </label>
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-8">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="">{PROPERTY_WEBSITE.first_name}</label>
                <input
                  type="text"
                  name="first_name"
                  className="form-control"
                  placeholder={PROPERTY_WEBSITE.first_name}
                  value={info?.first_name || ''}
                  onChange={(e) =>
                    handleChangeAgentInput({
                      e,
                      id: info.id || info._id,
                    })
                  }
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="">{PROPERTY_WEBSITE.last_name}</label>
                <input
                  type="text"
                  name="last_name"
                  className="form-control"
                  placeholder={PROPERTY_WEBSITE.last_name}
                  value={info?.last_name || ''}
                  onChange={(e) =>
                    handleChangeAgentInput({
                      e,
                      id: info.id || info._id,
                    })
                  }
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <label htmlFor="">{PROPERTY_WEBSITE.short_Description}</label>
                <EditorComponent
                  data={description}
                  setEditorValue={setEditorValue}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-group">
            <label htmlFor="">{PROPERTY_WEBSITE.address}</label>
            <input
              type="text"
              name="address"
              className="form-control"
              placeholder="Enter address"
              value={info?.address || ''}
              onChange={(e) =>
                handleChangeAgentInput({
                  e,
                  id: info.id || info._id,
                })
              }
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <label htmlFor="">{PROPERTY_WEBSITE.phone}</label>
            <input
              type="text"
              name="telephone"
              className="form-control"
              placeholder={PROPERTY_WEBSITE.enter_phone_number}
              value={info?.telephone || ''}
              onChange={(e) =>
                handleChangeAgentInput({
                  e,
                  id: info.id || info._id,
                })
              }
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <label htmlFor="">{PROPERTY_WEBSITE.website}</label>
            <input
              type="text"
              name="website"
              className="form-control"
              placeholder={PROPERTY_WEBSITE.enter_website}
              value={info?.website || ''}
              onChange={(e) =>
                handleChangeAgentInput({
                  e,
                  id: info.id || info._id,
                })
              }
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <label htmlFor="">{PROPERTY_WEBSITE.email}</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder={PROPERTY_WEBSITE.enter_email}
              value={info?.email || ''}
              onChange={(e) =>
                handleChangeAgentInput({
                  e,
                  id: info.id || info._id,
                })
              }
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="form-group">
            <label htmlFor="">{PROPERTY_WEBSITE.title}</label>
            <input
              type="text"
              name="title"
              className="form-control"
              placeholder={PROPERTY_WEBSITE.enter_title}
              value={info?.title || ''}
              onChange={(e) =>
                handleChangeAgentInput({
                  e,
                  id: info.id || info._id,
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
